import getPolicyAwareNotificationsEnabled from "../utils/getPolicyAwareNotificationsEnabled";

export default function areNotificationsDisabled(): boolean {
    return !getPolicyAwareNotificationsEnabled();
}
